import { render, staticRenderFns } from "./booking-section.vue?vue&type=template&id=6b18f82a&"
import script from "./booking-section.vue?vue&type=script&lang=js&"
export * from "./booking-section.vue?vue&type=script&lang=js&"
import style0 from "./booking-section.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports